var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flightsDashboard",class:'flightsDashboard--' + _vm.dashboardType},[_c('vue-scroll',{attrs:{"ops":_vm.ops}},[_c('FlightsDashboardHistorical',{attrs:{"historicalFlights":_vm.historicalFlights}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }